// Core
import React, { useState, useEffect } from 'react';
import {
  Card, Row, Col, Input, Table, Modal, Form, Select, notification
} from 'antd';
import { Link, useParams, useHistory } from 'react-router-dom';
import FontAwesome from 'react-fontawesome';
import { PageHeader } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';

// App
import { Main, TableWrapper } from '../../styled';
import { Button } from '../../../components/buttons/buttons';
import {
  pacienteServicioCreateAction,
  pacienteServicioListAction
} from '../../../redux/clinica/pacientes/actionCreator';
import PacienteConceptosView from '../conceptos/PacienteConceptos';
import BuscadorProductosServicios from '../conceptos/BuscadorCatalogo';
import { TipoTransaccion } from './../../../config/api/enums';


const { Search } = Input;
const gridStyle = {
  width: '33%',
  textAlign: 'center',
};

const CorteDiaByFormaPagoView = ({ setSubmenu }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const isLoading = useSelector(state => state.responseReducer.loading);
  const compras = useSelector(state => state.PacienteReducer.compras);
  const catalogoFormasPago = useSelector(state => state.CatalogosReducer.formasPago);
  const [modalVisible, setModalVisible] = useState(false);
  const [form] = Form.useForm();
  const { id } = useParams();

  const handleServicio = async (registro) => {
    const params = {
      action: 'compra-caja',
      id: 0,
      idServicio: registro.record.id,
      idPaciente: id,
      idTipoTransaccion: TipoTransaccion.VentaMostrador,
      idRecepcionista: 0,
      idDentista: 1,
    };
    const responseApi = await dispatch(pacienteServicioCreateAction(params));
    if (responseApi) {
      let mensaje = 'Servicio agregado a la compra';
      notification.success({
        message: mensaje,
      });
      // Recargar lista de conceptos a cobrar al paciente
      dispatch(pacienteServicioListAction(id, TipoTransaccion.Todos));
    } else {
      notification.success({
        message: 'Error al procesar presupuesto',
      });
    }
  };

  const hideModal = async () => {
    form.resetFields();
    setModalVisible(false);
  };

  const handleSubmit = async values => {
    console.log('handleSubmit.values: ', values);
    notification.error({
      message: 'Cobro realizado correctamente',
    });
    hideModal();

    return
    const responseApi = await dispatch(pacienteServicioCreateAction(values));
    if (responseApi) {
      let mensaje = 'Nota de evolución registrada exitosamente';
      notification.success({
        message: mensaje,
      });
      // Recargar lista de servicios en compras
      dispatch(pacienteServicioListAction(id, 2));
      hideModal();
      setBuscadorVisible(false);
    } else {
      notification.error({
        message: 'Error al procesar historial clínico',
      });
    }
  };

  

  return (
    <>
      <Card>
       Corte por forma de pago     
      </Card>      
    </>
  );
};

export default CorteDiaByFormaPagoView;
